export const HOUSEHOLD_SEARCH_DEBOUNCE_MS = 650;

/** Server `filter[q]` on household comboboxes — aligned with households list search (min 3). */
export const HOUSEHOLD_COMBOBOX_SERVER_Q_MIN_LENGTH = 3;

export function buildHouseholdComboboxFilter(
  base: Record<string, unknown>,
  trimmedQuery: string,
): Record<string, unknown> {
  if (trimmedQuery.length >= HOUSEHOLD_COMBOBOX_SERVER_Q_MIN_LENGTH) {
    return {...base, q: trimmedQuery};
  }
  return base;
}

export function nextHouseholdComboboxFilter(
  oldFilter: Record<string, unknown> | undefined,
  base: Record<string, unknown>,
  trimmedQuery: string,
): {changed: boolean; filter: Record<string, unknown>} {
  const nextFilter = buildHouseholdComboboxFilter(base, trimmedQuery);
  const prevQ = typeof oldFilter?.q === "string" ? oldFilter.q : "";
  const nextQ = typeof nextFilter.q === "string" ? nextFilter.q : "";
  if (prevQ === nextQ) {
    return {changed: false, filter: nextFilter};
  }
  return {changed: true, filter: nextFilter};
}

export function householdComboboxEmptyMessage(activeSearch: string): string {
  const trimmed = activeSearch.trim();
  if (
    trimmed.length > 0 &&
    trimmed.length < HOUSEHOLD_COMBOBOX_SERVER_Q_MIN_LENGTH
  ) {
    return `Type at least ${HOUSEHOLD_COMBOBOX_SERVER_Q_MIN_LENGTH} characters to search households`;
  }
  return "No households found";
}

export function householdComboboxIsLoading(_activeSearch: string, isFetching: boolean): boolean {
  return isFetching;
}
